import * as React from 'react';
import { H2 } from '@grandvisionhq/iris-ui';

const ProductBlockHeading = ({ children  })=>{
    return /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-smallest",
        className: "v2-product-block-heading"
    }, children);
};

export { ProductBlockHeading };
//# sourceMappingURL=ProductBlockHeading.js.map
